import { InjectionToken } from "@angular/core";
import { CurrentPeriodPort } from "./current-period.port";

export const CURRENT_PERIOD_PORT =
  new InjectionToken<CurrentPeriodPort>("CURRENT_PERIOD_PORT");
